import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetSetting } from "./service";

export const useGetSetting = (options) => {
  return useQuery([queryKey.WIN_SETTING], () => apiGetSetting().then((res) => res.data.data), {
    ...options,
  });
};
